// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2toiZ","row":"ProcedureTreatmentSummary_row__2Uu9K"};